module.exports = __webpack_public_path__ + "static/media/p3.9346e88e.png";